module.exports = __webpack_public_path__ + "static/img/q.ae526526.webp";